import React from 'react';

import MyTISection from './Section';

const MyTIDeepResearch = () => {
  return (
    <MyTISection
      highlight="Label"
      subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit"
      title="Deep Research"
    >
      <div>Deep Research</div>
    </MyTISection>
  );
};

export default MyTIDeepResearch;
